import colors from "../../../constants/colors";

const styles = (theme) => {
  return {
    box: {
      marginLeft: "5%",
      marginRight: "5%",
    },
    label: {
      "white-space": "nowrap",
      [theme.breakpoints.down("sm")]: {
        fontSize: 13,
      },
      [theme.breakpoints.up("sm")]: {
        fontSize: 15,
      },
    },
    chips: {
      display: "flex",
      flexWrap: "wrap",
    },
    imageList: {
      width: "80%",
      height: "80%",
    },
    chip: {
      "font-weight": "bold",
      "font-size": "12px",
      "font-family": "Montserrat",
      color: colors.black,
      maxWidth: "250px",
      marginLeft: 4,
      marginRight: 4,
    },
    texts: {
      "font-weight": "bold",
      "font-family": "Montserrat",
    },
    avatar: {
      width: "10%",
    },
    name: {
      width: "30%",
    },
    price: {
      width: "20%",
    },
    amount: {
      width: "20%",
    },
    error: {
      color: colors.htmlRed,
      "font-weight": "bold",
      "font-family": "Montserrat",
    },
  };
};

export default styles;
